const INVOICE_STATUS_CLASSNAME = {
  // Aberta -> Azul Will (accent-blue)
  // Paga -> Verde
  // Cancelada -> Azul/Cinza padrão
  // Aguardando Reembolso -> Vermelho
  // Reembolsado -> Vermelho
  // Duplicada -> Azul/Cinza padrão
  // Expirada -> Azul/Cinza padrão
  // Em Recuperacao -> Amarelo
  0: '',
  1: 'aberta-blue',
  2: '',
  3: 'paga',
  4: 'aberta',
  5: '',
  6: 'reembolsado',
  7: 'reembolsado',
  8: 'aberta-blue',
  9: 'aberta',
  10: 'aberta',
  11: 'recuperacao',
  12: 'aberta',
  13: 'aberta',
  14: 'aberta',
  15: 'aberta',
  19: 'negociada',
};

const SUBSCRIPTIONS_STATUS_CLASSNAME = {
  // Aberta -> Azul Will (accent-blue)
  // Paga -> Verde
  // Cancelada -> Azul/Cinza padrão
  // Aguardando Reembolso -> Vermelho
  // Reembolsado -> Vermelho
  // Duplicada -> Azul/Cinza padrão
  // Expirada -> Azul/Cinza padrão
  // Em Recuperacao -> Amarelo
  1: 'paga',
  2: 'aberta-blue',
  3: 'reembolsado',
  4: 'reembolsado',
  7: 'recuperacao',
  9: 'paga',
  10: 'paga',
  11: 'recuperacao',
};

const SUBSCRIPTIONS_NEXT_STATUS_CLASSNAME = {
  // Aberta -> Azul Will (accent-blue)
  // Paga -> Verde
  // Cancelada -> Azul/Cinza padrão
  // Aguardando Reembolso -> Vermelho
  // Reembolsado -> Vermelho
  // Duplicada -> Azul/Cinza padrão
  // Expirada -> Azul/Cinza padrão
  // Em Recuperacao -> Amarelo
  1: 'paga',
  2: 'recuperacao',
  3: 'duplicada',
  4: 'reembolsado',
  5: 'aberta-blue',
};

const SUBSCRIPTIONS_NEXT_STATUS_NAME = {
  1: 'Ativo',
  2: 'Desabilitado',
  3: 'Vencido',
  4: 'Cancelado',
  5: 'Finalizado',
};

// enum para classes dos produtos
const PRODUCT_STATUS_CLASS = {
  /*
      P : pendente
      R : Reporvado
      N : Nada
      A : Aprovado
    */
  P: '-moderation',
  R: '-disapproved',
  N: '-waiting',
  A: '-approved',
};
// enum para os status (nome) dos produtos
const PRODUCT_STATUS = {
  /*
      P : pendente
      R : Reporvado
      N : Nada
      A : Aprovado
    */
  P: 'Em moderação',
  R: 'Reprovado',
  N: 'Rascunho',
  A: 'Aprovado',
};
// enum para os status dos dados bancários
const BANK_ACCOUNT_STATUS = {
  'Aguardando Retorno do Banco': '--bank-return',
  Ativo: '--active',
  Cancelado: '--canceled',
  Pendente: '--pending',
  Desconhecido: '--undefined',
};
// enum para tipo de moeda
const ACCOUNT_CURRENCY = {
  0: 'BRL',
  1: 'BRL',
  2: 'USD',
  3: 'EUR',
};

const INVOICE_STATUS_NAME = {
  0: '',
  1: 'Aberta',
  2: '',
  3: 'Paga',
  4: 'Cancelada',
  5: '',
  6: 'Aguardando Reembolso',
  7: 'Reembolsado',
  8: '',
  9: 'Duplicada',
  10: 'Expirada',
  11: 'Em recuperação',
  12: 'Aberta',
  13: 'Aberta',
  14: 'Aberta',
  15: 'Aguardando Pagamento',
  19: 'Negociada',
};

const SUBSCRIPTIONS_STATUS_NAME = {
  2: 'Aguardando Pagamento',
  7: 'Atrasado',
  4: 'Cancelado',
  1: 'Em Dia',
  9: 'Finalizado',
  11: 'Inadimplente',
  19: 'Negociada',
  3: 'Suspenso',
  10: 'Trial',
};

export const enums = {
  INVOICE_STATUS_CLASSNAME,
  SUBSCRIPTIONS_STATUS_CLASSNAME,
  PRODUCT_STATUS_CLASS,
  PRODUCT_STATUS,
  BANK_ACCOUNT_STATUS,
  ACCOUNT_CURRENCY,
  INVOICE_STATUS_NAME,
  SUBSCRIPTIONS_STATUS_NAME,
  SUBSCRIPTIONS_NEXT_STATUS_CLASSNAME,
  SUBSCRIPTIONS_NEXT_STATUS_NAME,
};

export enum EProductStatus {
  INACTIVE,
  ACTIVE,
  ARCHIVE,
  DRAFT,
}

export const PRODUCT_STATUS_LABEL: { [key: string]: string } = {
  inactive: 'Inativo',
  active: 'Ativo',
  filed: 'Arquivado',
  draft: 'Em rascunho',
};
